export const espacamento = {
  extraGrande: 48,
  grande: 36,
  medio: 24,
  pequeno: 12,
  extraPequeno: 8,
  ultraPequeno: 4,
};

export const bordaArredondar = 4;
